var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01855,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#ECFDF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01855,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#079455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5186H29M12 12.5186V22.5186C12 23.049 12.2107 23.5577 12.5858 23.9328C12.9609 24.3078 13.4696 24.5186 14 24.5186H26C26.5304 24.5186 27.0391 24.3078 27.4142 23.9328C27.7893 23.5577 28 23.049 28 22.5186V12.5186M20 24.5186V28.5186M17 28.5186H23",
    stroke: "#17B26A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5186L19 17.5186L21 19.5186L24 16.5186",
    stroke: "#17B26A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIconOn);
export default __webpack_public_path__ + "static/media/presentation_icon_on.21e338bcff043de22477279da4a59ffc.svg";
export { ForwardRef as ReactComponent };